import {faFileAlt, faFileExcel, faFilePdf, faFileWord} from "@fortawesome/free-solid-svg-icons";
import Holidays from "date-holidays";

export function parseJwt(token) {
    if (token === null) return null
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

export function mapConsultationResult(result) {
    const resultMap = {
        'AGREEMENT': 'Dohoda o spolupráci obce s RC',
        'NEXT_CONSULTATION_NEEDED': 'Je nutná další konzultace',
        'NOT_INTERESTED': 'Obec nemá zájem o spolupráci',
        'OTHER': 'Jiný výsledek'
    };

    return resultMap[result] || 'Neznámý výsledek';
}

export function mapRating(result) {
    const resultMap = {
        '1': '1 - vynikající',
        '2': '2 - chvalitebná',
        '3': '3 - dobrá',
        '4': '4 - dostatečná',
        '5': '5 - nedostatečná'
    };

    return resultMap[result] || 'Hodnocení není uvedeno';
}

export function mapRegionalCenter(result) {
    const regionalCenter = {
        0: "Všechna regionální centra",
        1: "Moravskoslezský kraj",
        2: "Středočeský kraj a Praha",
        3: "Ústecký a Karlovarský kraj",
        4: "Královehradecký a Liberecký kraj",
        5: "Pardubický kraj a kraj Vysočina",
        6: "Jihočeský kraj a Plzeňský kraj",
        7: "Zlínský a Jihomoravský kraj",
        8: "Olomoucký kraj"
    }
    return regionalCenter[result] || 'Neznámé regionální centrum';
}

export function getRegionalCenterIds(regionalCenter) {
    if (regionalCenter === undefined || regionalCenter === null || regionalCenter === "" || regionalCenter.toString() === "0") {
        return ["1", "2", "3", "4", "5", "6", "7", "8"];
    }
    return [regionalCenter.toString()];
}

export function getMonthsInRange(from, to) {
    if (!from || !to) {
        return [];
    }
    const [fromYear, fromMonth] = from.split('-').map(Number);
    const [toYear, toMonth] = to.split('-').map(Number);

    const months = [];
    let currentMonth = new Date(fromYear, fromMonth - 1);
    const lastMonth = new Date(toYear, toMonth - 1);

    while (currentMonth <= lastMonth) {
        months.push(`${currentMonth.getFullYear()}-${String(currentMonth.getMonth() + 1).padStart(2, '0')}`);
        currentMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1);
    }

    return months;
}

export function getFirstDayOfMonth(yearMonth) {
    return `${yearMonth}-01`;
}

export function getLastDayOfMonth(yearMonth) {
    const [year, month] = yearMonth.split('-').map(Number);
    const lastDay = new Date(year, month, 0).getDate();
    return `${yearMonth}-${String(lastDay).padStart(2, '0')}`;
}

export function mapProjectType(result) {
    const resultMap = {
        '0': 'Není vybráno',
        '1': 'Nákup',
        '2': 'Stavba',
        '3': 'Rekonstrukce',
        '4': 'Mix'
    };

    return resultMap[result] || 'Neznámý typ';
}

export function mapFinancingType(result) {
    const resultMap = {
        '0': 'Tato hodnota aktuálně chybí',
        '1': '4.1.3 – Podpora přípravy projektů',
        '2': '2.10 – Dostupné bydlení',
        '3': 'IROP – Sociální bydlení',
        '4': 'PPP – Spolu-investice žadatele s bankou, developerem, investorem, apod.',
        '5': 'Vlastní zdroje investora',
        '6': 'Komerční úvěr',
        '7': 'Jiné',
        '8': 'SFPI – Bytové domy bez bariér',
        '9': 'SFPI – Technická infrastruktura',
        '10': '2.10 – NRB',
        '11': 'Veřejná investice',
        '12': 'Strategická veřejná investice',
        '13': 'DNB 2',
        '14': 'Družstevní bydlení',
        '15': 'DNB 3'
    };

    return resultMap[result] || 'Neznámý typ financování';
}

export function mapBuildingPurpose(result) {
    const resultMap = {
        '1': 'Prodej bytů',
        '2': 'Pronájem tržní',
        '3': 'Pronájem zvýhodněný',
        '4': 'Mix'
    };

    return resultMap[result] || 'Neznámý účel bytové výstavby';
}

export function mapTargetGroup(result) {
    const resultMap = {
        '0': 'Tato hodnota aktuálně chybí',
        '1': 'Seniorské bydlení',
        '2': 'Pro mladé do 35 let',
        '3': 'Zdravotnický personál',
        '4': 'Armáda, policie, hasiči',
        '5': 'Ostatní preferované profese',
        '6': 'Žádné zaměření',
        'OTHER_PREFERRED_PROFESSIONS': 'Ostatní preferované profese',
        'YOUTH_UNDER_35': 'Pro mladé do 35 let'
    };

    return resultMap[String(result ?? '').trim()] || 'Tato hodnota aktuálně chybí';
}

export function mapProjectPhase(result) {
    const resultMap = {
        '1': 'Vize',
        '2': 'Předprojektová příprava',
        '3': 'Projektová fáze',
        '4': 'Stavební povolení - příprava na realizaci',
        '5': 'Realizace a provoz budovy'
    };

    return resultMap[result] || 'Neznámá fáze';
}

export function mapTimeSheetType(result) {
    const resultMap = {
        '-1': 'Dovolená',
        '1': 'Administrativa',
        '2': 'Obec',
        '3': 'Projekt',
        '4': 'Konzultace MMR',
        '5': 'Školení',
        '6': 'Cesta',
        '7': 'Konzultace',
        '8': 'Interní projekt'
    };

    return resultMap[result] || 'Neznámý typ';
}

export function mapWorkAgreementType(result) {
    const resultMap = {
        '1': 'HPP',
        '2': 'DPČ'
    };

    return resultMap[result] || 'Neznámý typ pracovního poměru';
}

export function mapTransportType(value) {
    const transportTypeMap = {
        '1': 'Veřejná doprava',
        '2': 'Soukromé vozidlo',
        '3': 'Vozidlo SFPI',
        '4': 'Spolujízda'
    };

    return transportTypeMap[value] || 'Neznámý dopravní prostředek';
}

export function convertUtilizationToPercentage(value) {
    return (value * 100).toFixed(2);
}

export function convertIsoToCustomFormat(isoString) {
    let date = new Date(isoString);

    let day = String(date.getUTCDate()).padStart(2, '0');
    let month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    let year = date.getUTCFullYear();


    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export function convertIsoToCustomFormatForDocuments(isoString) {
    let date = new Date(isoString);

    let day = String(date.getUTCDate()).padStart(2, '0');
    let month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    let year = date.getUTCFullYear();


    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} v ${hours}:${minutes}`;
}

export function convertIsoToDateFormat(inputDate) {
    let date = new Date(inputDate);
    let month = date.getMonth() + 1; // Months are zero based
    let day = date.getDate();
    let year = date.getFullYear();

    // Ensure day and month are two digits
    day = day < 10 ? '0' + day : day;
    month = month < 10 ? '0' + month : month;

    return `${day}.${month}.${year}`;
}

export function convertIsoToTime(isoString) {
    let date = new Date(isoString);
    let hours = String(date.getHours()).padStart(2, '0');
    let minutes = String(date.getUTCMinutes()).padStart(2, '0');

    return `${hours}:${minutes}`;
}

export function convertIsoToLocalDate(isoDate) {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export function convertIsoToLocalDateTime(isoDate) {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export function convertDateToDDMMYYYY(dateString) {
    if (!dateString || !dateString.includes('-')) {
        return 'Datum není vyplněno';
    }

    const [year, month, day] = dateString.split('-');

    if (!year || !month || !day) {
        return 'Datum není vyplněno';
    }

    return `${day}.${month}.${year}`;
}

export function convertDateToDDMM(dateString) {
    if (!dateString || !dateString.includes('-')) {
        return 'Datum není vyplněno';
    }

    const [year, month, day] = dateString.split('-');

    if (!year || !month || !day) {
        return 'Datum není vyplněno';
    }

    return `${day}.${month}.`;
}

export function parseIsoToYearMonth(isoDate) {
    const date = new Date(isoDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // +2 because we want the next month after the given date
    return `${year}-${month}`;
}

export function mapDateFormat(dateString) {
    const [year, month] = dateString.split('-');
    return `${month}.${year}`;
}

export function externalRoleToText(role) {
    const roleMap = {
        'STATUTORY_DEPUTY': 'Statutární zástupce',
        'DELEGATE': 'Zmocněnec',
        'OBSERVER': 'Nahlížející osoba',
        'CONTACT_PERSON': 'Kontaktní osoba',
        'OTHER': 'Jiná role'
    };

    return roleMap[role] || 'Role nenalezena';
}

export function userRoleToText(role) {
    const roleMap = {
        'NON_ACTIVE': 'Neaktivní uživatel',
        'CONTACT_PERSON': 'Kontaktní osoba',
        'RC_EMPLOYEE': 'Specialista regionálního centra',
        'HEADQUARTERS': 'Zaměstnanec centrály',
        'HQ_WITH_REPORT': 'Zaměstnanec centrály+',
        'RC_LEADER': 'Manažer regionálního centra'
    };

    return roleMap[role] || 'Role nenalezena';
}

export function approvalStateToText(role) {
    const roleMap = {
        'CREATED': 'Ke schválení vedoucím',
        'APPROVED_BY_SUPERVISOR': 'Schváleno vedoucím',
        'REJECTED_BY_SUPERVISOR': 'Zamítnuto vedoucím',
        'APPROVED_BY_HQ': 'Schváleno centrálou',
        'REJECTED_BY_HQ': 'Zamítnuto centrálou',


    };

    return roleMap[role] || 'Neznámý stav';
}

export function auditReportToText(auditType) {
    const roleMap = {
        'SFPIREPORT': 'Report SFPI',
        'MMRREPORT': 'Report MMR',
    };

    return roleMap[auditType] || 'Neznámý typ';
}


export function typeToText(subjectType) {
    const typeMap = {
        'TOWN': 'Obec/město/městská část',
        'FUNDED_ORGANIZATION': 'Příspěvková organizace',
        'COUNTRY': 'Stát',
        'CHURCH': 'Církev',
        'PRIVATE': 'Privátní subjekt',
        'ASSOCIATION': 'Spolek'
    };

    return typeMap[subjectType] || 'Typ nenalezen';
}

export function fuelTypeToText(type) {
    const typeMap = {
        '1': 'Natural 95',
        '2': 'Natural 98',
        '3': 'Diesel',
        '4': 'Elektrický pohon',
    };

    return typeMap[type] || 'Typ paliva nenalezen';
}

export function getPersonRole(person) {
    if (person.role !== undefined) {
        return person.role
    } else if (person.roleValue !== undefined) {
        return person.roleValue
    } else {
        return person.role[0].authority
    }
}

export function getIcon(documentName) {
    const extension = documentName.split('.').pop().toLowerCase();

    switch (extension) {
        case 'pdf':
            return faFilePdf;
        case 'xlsx':
        case 'xls':
            return faFileExcel;
        case 'docx':
        case 'doc':
            return faFileWord;
        default:
            return faFileAlt; // or some default icon
    }
}

export function checkIfDayIsWeekendOrHoliday(chosenDay) {
    const isWeekend = chosenDay.getDay() === 0 || chosenDay.getDay() === 6;
    const hd = new Holidays('CZ');
    const isHoliday = hd.isHoliday(chosenDay)
    const isPublicHoliday = isHoliday && isHoliday[0].type === 'public';

    return isWeekend || isPublicHoliday;
}

// Očekávaná výše investice (v mil. Kč) - desetinným oddělovačem je tečka,
// maximálně 4 číslice před ní a 1 číslice za ní. Napsanou čárku rovnou
// převedeme na tečku, aby šla hodnota odeslat na API jako číslo.
export function sanitizeInvestmentAmount(rawValue) {
    let val = (rawValue === null || rawValue === undefined) ? "" : String(rawValue);
    val = val.replace(/[^0-9.,]/g, "").replace(/,/g, ".");
    const parts = val.split(".");
    const intPart = parts[0].slice(0, 4);
    if (parts.length > 1) {
        // uživatel už napsal tečku - necháme ji, aby mohl dopsat desetinné místo
        return intPart + "." + parts[1].slice(0, 1);
    }
    return intPart;
}

// Vynutí oříznutou hodnotu i v samotném inputu (web komponenta si drží vlastní
// hodnotu, takže samotný React state by přebytečné číslice nesmazal).
export function forceInvestmentAmountValue(target, value) {
    if (!target) {
        return;
    }
    if (target.value !== value) {
        target.value = value;
    }
    const innerInput = (target.querySelector && target.querySelector("input"))
        || (target.shadowRoot && target.shadowRoot.querySelector("input"));
    if (innerInput && innerInput.value !== value) {
        innerInput.value = value;
    }
}

// Hodnota pro odeslání na API - bez ukončovací desetinné tečky. Prázdné pole
// posíláme jako null, ať se na API neuloží prázdný řetězec.
export function normalizeInvestmentAmount(value) {
    if (value === null || value === undefined) {
        return null;
    }
    const normalized = String(value).replace(/\.$/, "").replace(/^\./, "0.");
    return normalized === "" ? null : normalized;
}
